export default "__VITE_ASSET__mv$hp0AN__"